import { Wrapper } from './styles';

const BackgroundImage = ({ img, children, ...props }) => (
  <Wrapper img={img} {...props}>
    {children}
  </Wrapper>
);

export default BackgroundImage;
